// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".small-details-logo-options{width:100%}.bx--radio-button-group--vertical{width:100%;padding:0 15px;margin-bottom:10px}", ""]);
// Exports
module.exports = exports;
